<template>
    <el-dialog
            title="提示"
            :visible.sync="dialogVisible"
            width="30%"
            :modal="false"
            :before-close="handleClose">
            <div class="warn-info">
                <p class="warn">{{warn[type]}}</p>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="handleClose">确 定</el-button>
              </span>
    </el-dialog>
</template>

<script>
    export default {
        name: "warn-info",
        created(){
            this.$nextTick(()=>{
                $eventBus.$on('showWarnInfo', this.showWarnInfo)
            })
        },
        data(){
            return {
                type: '',
                warn: {
                    addVideo: '当前为前景视频可编辑(层级最高)，点击播放可进行预览',
                    addVideoBackground: '当前为背景视频不可缩放，支持叠加小工具答题'
                },
                dialogVisible: false
            }
        },
        methods: {
            showWarnInfo(type){
                this.dialogVisible = true
                this.type = type
            },
            handleClose(){
                this.dialogVisible = false
                this.$store.state.operationSteps.push(this.$enums.operationStep.toConfig)
            }
        }
    }
</script>

<style lang="scss" scoped>
.warn-info{
    position: absolute;
    z-index: 100;
}
</style>
